import { ReactElement } from 'react'
import { useSchedulingUnavailable } from 'app/components/scheduling-unavailable/useSchedulingUnavailable'
import { SchedulingUnavailableShadcnComponent } from 'app/components/scheduling-unavailable/SchedulingUnavailableShadcnComponent'

export default function SchedulingUnavailable(): ReactElement {
  const props = useSchedulingUnavailable()
  return <SchedulingUnavailableShadcnComponent {...props} />
}
